import { Injectable } from '@angular/core';
import { uniq } from 'ramda';
import { EStoreType } from '@gelato-api-ui/core/e-commerce/e-store-type.enum';
import { EProductImage } from '@gelato-api-ui/core/e-commerce/e-product-image';
import { EProductImageStatus } from '@gelato-api-ui/core/e-commerce/e-product-image-status.enum';

@Injectable({ providedIn: 'root' })
export class ECommerceProductImagesArrayService {
  getPrimaryProductImage(productImages: EProductImage[]): EProductImage {
    if (!productImages?.length) {
      return null;
    }

    return productImages.find(
      (loopProductImage: EProductImage): boolean =>
        loopProductImage.isPrimary && loopProductImage.status !== EProductImageStatus.DELETED,
    );
  }

  getPrimaryProductImageUrl(productImages: EProductImage[]): string {
    const primaryProductImage = this.getPrimaryProductImage(productImages);

    return primaryProductImage ? primaryProductImage.fileUrl : null;
  }

  mergeDuplicateProductImages(eProductImages: EProductImage[], eStoreType: EStoreType): EProductImage[] {
    if (![EStoreType.SHOPIFY, EStoreType.ETSY].includes(eStoreType)) {
      return eProductImages;
    }

    const primaryProductImage = this.getPrimaryProductImage(eProductImages);

    if (primaryProductImage) {
      const duplicateProductVariantImages = eProductImages.filter(
        loopProductImage => loopProductImage?.fileUrl === primaryProductImage?.fileUrl,
      );

      let productVariantIds = [];
      let productVariantKeys = [];

      duplicateProductVariantImages.forEach(loopProductImage => {
        productVariantIds = [...productVariantIds, ...(loopProductImage?.productVariantIds || [])];
        productVariantKeys = [...productVariantIds, ...(loopProductImage?.productVariantKeys || [])];
      });

      return [
        {
          ...primaryProductImage,
          productVariantIds: uniq(productVariantIds),
          productVariantKeys: uniq(productVariantKeys),
        },
        ...eProductImages.filter(loopProductImage => loopProductImage?.fileUrl !== primaryProductImage?.fileUrl),
      ];
    }

    return eProductImages;
  }
}
